import { useState } from "react";
import { Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/lib/api";
import { apiError, photoUrl } from "@/lib/reviews";
import { useInstagram } from "@/components/shop/InstagramGallery";

const admin = axios.create({ baseURL: API, withCredentials: true });

export const InstagramAdmin = () => {
  const { data = [], refetch } = useInstagram();
  const [account, setAccount] = useState("hr");
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);

  const upload = async (files) => {
    if (!files.length) return;
    setBusy(true);
    let ok = 0;
    for (const f of files) {
      const fd = new FormData();
      fd.append("account", account);
      fd.append("post_url", files.length === 1 ? link.trim() : "");
      fd.append("photo", f);
      try { await admin.post("/admin/instagram", fd); ok += 1; } catch (x) { toast.error(apiError(x)); }
    }
    if (ok) { toast.success(`Dodano fotografija: ${ok}`); setLink(""); }
    refetch();
    setBusy(false);
  };

  const remove = async (id) => {
    if (!window.confirm("Obrisati ovu fotografiju iz galerije?")) return;
    try { await admin.delete(`/admin/instagram/${id}`); refetch(); } catch (x) { toast.error(apiError(x)); }
  };

  return (
    <section data-testid="admin-instagram" className="mt-14">
      <h2 className="font-display text-3xl mb-2">Instagram galerija</h2>
      <p className="text-sm text-white/50 mb-6">Fotografije se prikazuju na naslovnici (zadnjih 12). Klik vodi na objavu ako upišete link, inače na odabrani profil.</p>
      <div className="border border-white/10 p-6 grid sm:grid-cols-[160px_1fr_auto] gap-3 items-center">
        <select data-testid="admin-ig-account-select" value={account} onChange={(e) => setAccount(e.target.value)} className="h-11 bg-[#0e0d0b] border border-white/15 px-3 text-sm">
          <option value="hr">@ajsluxury.hr</option><option value="de">@ajsluxury.de</option><option value="en">@ajsluxury.en</option>
        </select>
        <input data-testid="admin-ig-link-input" value={link} onChange={(e) => setLink(e.target.value)} placeholder="Link objave (neobavezno, za jednu fotografiju)" className="h-11 bg-transparent border border-white/15 px-3 text-sm" />
        <label className={`btn-gold h-11 px-6 inline-flex items-center gap-2 cursor-pointer ${busy ? "opacity-60 pointer-events-none" : ""}`}>
          <Upload size={15} />{busy ? "Učitavanje…" : "Dodaj fotografije"}
          <input data-testid="admin-ig-file-input" type="file" multiple accept="image/jpeg,image/png,image/webp" hidden onChange={(e) => { upload([...e.target.files]); e.target.value = ""; }} />
        </label>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 mt-4">
        {data.map((p) => (
          <div key={p.id} data-testid={`admin-ig-item-${p.id}`} className="relative group">
            <img src={photoUrl(p.image)} alt="" className="aspect-square w-full object-cover" />
            <span className="absolute bottom-1 left-1 text-[10px] bg-black/70 px-1">{p.account.toUpperCase()}</span>
            <button data-testid={`admin-ig-delete-${p.id}`} onClick={() => remove(p.id)} aria-label="Obriši" className="absolute top-1 right-1 h-7 w-7 bg-black/70 flex items-center justify-center hover:text-red-400"><Trash2 size={12} /></button>
          </div>
        ))}
      </div>
    </section>
  );
};
